import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { utcToReport } from "../../../utils/dateConvert";
class Summary extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const report = this.props.reportDetail;

    return (
      <div className="summary">
        <div class="subHeading">
          <h1>
            <i className="fa fa-bar-chart"></i> Summary
          </h1>
        </div>

        <div className="summaryBody">
          <div className="summaryBodyContent">
            <Row>
              <Col>
                <div className="summaryHead">
                  {" "}
                  <span className="subHead">{report.assetName}</span>
                  &nbsp;&nbsp;&nbsp;
                  {report.speakerandMic && (
                    <i
                      className=" fa fa-microphone reportHeadIcons"
                      title="Speaker & Mic"
                    />
                  )}
                  {report.sosDuress && (
                    <i
                      className="fa fa-life-saver reportHeadIcons"
                      title="SOS(Duress)"
                    />
                  )}
                  {(report.tempA || report.tempB) && (
                    <i
                      className="fa fa-thermometer-full reportHeadIcons redColor"
                      title={`${report.tempA ? "Temperature A" : ""} ${report.tempB ? "Temperature B" : ""}`}
                    />
                  )}
                  {report.harshEvents && (
                    <i
                      className="fa fa-bolt reportHeadIcons"
                      title="Harsh Events"
                    />
                  )}
                  {report.driverID && (
                    <i
                      className="fa fa-id-card-o reportHeadIcons"
                      title="Driver ID"
                    />
                  )}
                  {report.dashCamera && (
                    <i
                      className="fa fa-camera reportHeadIcons"
                      title="Dash Camera"
                    />
                  )}
                  <span className="generated">
                    Generated : {this.props.generatedDate}
                  </span>{" "}
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-hourglass-start blueColor" />
                  <span className="gray"> Start:</span>{" "}
                  {utcToReport(report.start)}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="First Engine ON for day"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-hourglass-end blueColor" />
                  <span className="gray"> End:</span>{" "}
                  {utcToReport(report.end)}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Last engine OFF for day OR last device message"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-clock-o blueColor" />
                  <span className="gray"> Duration:</span> {report.duration}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Computed work day Time between Start and End"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-envelope grayColor" />
                  <span className="gray"> Processed:</span> {report.processed}
                  <i
                    className="fa fa-info-circle"
                    title="Total message received and processed for day"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-signal grayColor" />
                  <span className="gray"> GSM Loss:</span> {report.gsmLoss}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Percent of messages without a GSM signal"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-globe grayColor" />
                  <span className="gray"> GPS Loss:</span> {report.gpsLoss}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Percent of messages without a GPS Lock"
                  />
                </span>
                <br />
              </Col>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-building blueColor" />
                  <span className="gray"> Total Trips:</span>{" "}
                  {report.totalTrips}{" "}
                  <i
                    className="fa fa-info-circle"
                    title={`Trips: ${report.tripsCount} Virtual Trips: ${report.virtualTrips && report.virtualTrips.length}`}
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-truck goldColor" />
                  <span className="gray"> Engine:</span>{" "}
                  {report.engineHours}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-truck greenColor" />
                  <span className="gray"> Moving Engine Hours:</span>{" "}
                  {report.movingEngineHours}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Engine Hours - Virtual Parked"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-hand-paper-o blueColor" />
                  <span className="gray"> Parked:</span> {report.parked}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-hand-paper-o greenColor" />
                  <span className="gray"> Total Parked:</span>{" "}
                  {report.totalParked}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Parked + Virtual Parked"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-road blueColor" />
                  <span className="gray"> Distance:</span> {report.distance}{" "}
                </span>
                <br />
              </Col>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-calculator blueColor" />
                  <span className="gray"> Average Trip:</span>{" "}
                  {report.averageTrip}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Total Trips / Engine Hour"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-calculator greenColor" />
                  <span className="gray"> Average Parked:</span>{" "}
                  {report.averageParked}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Total Parked / Duration"
                  />
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-calculator blueColor" />
                  <span className="gray"> Average Distance:</span>{" "}
                  {report.averageDistance}{" "}
                  <i
                    className="fa fa-info-circle"
                    title="Total Trips / Distance"
                  />
                </span>
                <br />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="summaryHead">
                  {" "}
                  <span className="subSecHead">Events & Exceptions</span>{" "}
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-life-ring redColor" />
                  <span className="gray"> Duress:</span> {report.duress}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-battery-quarter redColor" />
                  <span className="gray"> Low Battery:</span>{" "}
                  {report.lowBattery}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-plug darkGrayColor" />
                  <span className="gray"> Powercut:</span> {report.powercut}{" "}
                </span>
                <br />
              </Col>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-reply-all goldColor" />
                  <span className="gray"> Harsh Turning:</span>{" "}
                  {report.harshTurning}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-fighter-jet  goldColor" />
                  <span className="gray"> Harsh Acceleration:</span>{" "}
                  {report.harshAcceleration}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-exclamation-triangle goldColor" />
                  <span className="gray"> Harsh Braking:</span>{" "}
                  {report.harshBraking}{" "}
                </span>
                <br />
              </Col>
              <Col>
                <span className="inlineDetail">
                  <i className="fa fa-balance-scale redColor" />
                  <span className="gray"> OH&S No Driver Break:</span>{" "}
                  {report.ohsNoDriverBreak}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-tachometer darkGrayColor" />
                  <span className="gray"> Overspeed:</span> {report.overspeed}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-thermometer-full darkGrayColor" />
                  <span className="gray"> Temperature:</span>{" "}
                  {report.temperature}{" "}
                </span>
                <br />
                <span className="inlineDetail">
                  <i className="fa fa-hourglass-half darkGrayColor" />
                  <span className="gray"> Parked Idle:</span>{" "}
                  {report.parkedIdle} ({report.parkedIdleDuration}){" "}
                </span>
                <br />
              </Col>
             </Row>
            {report.depot != null && (
            <span>
            <Row>
              <Col>
                <div className="summaryHead">
                  {" "}
                  <span className="subSecHead">
                    Depot : Started{" "}
                    <span className={report.startedInDepot ? "greenColor" : "orangeColor"}>{report.startedInDepot ? "inside" : "outside"}</span>{" "}
                    and finished{" "}
                    <span className={report.endedInDepot ? "greenColor" : "orangeColor"}>{report.endedInDepot ? "inside" : "outside"}</span>{" "}
                    depot
                  </span>{" "}
                </div>
              </Col>
            </Row>

            
              <Row>
                <Col>
                  <span className="inlineDetail">
                    <i className="fa fa-home grayColor" />
                    <span className="gray"> Depot:</span> {report.depot.depotName}
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-sign-in blueColor" />
                    <span className="gray"> First Entered:</span>{" "}
                    {utcToReport(report.firstEntered)}{" "}
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-sign-out blueColor" />
                    <span className="gray"> First Left:</span>{" "}
                    {utcToReport(report.firstLeft)}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="If started inside First Left = 1st Depot Exit Else started outside and First Left = 2nd Depot Exit Event Event"
                    />
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-sign-in blueColor" />
                    <span className="gray"> Last Entered:</span>{" "}
                    {utcToReport(report.lastEntered)}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="Last time the depot was entered, can be same as First Entered if only occurred once."
                    />
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-sign-out blueColor" />
                    <span className="gray"> Last Left:</span>{" "}
                    {utcToReport(report.lastLeft)}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="Last time the depot was exited, can be same as First Left if occurred once."
                    />
                  </span>
                  <br />
                </Col>
                <Col>
                  <span className="inlineDetail">
                    <i className="fa fa-clock-o blueColor" />
                    <span className="gray"> Duration outside:</span>{" "}
                    {report.durationOutside}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="Combined durations recorded outside of deport starting with First Left"
                    />
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-clock-o blueColor" />
                    <span className="gray"> Engine hours outside:</span>{" "}
                    {report.engineHoursOutside}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="Duration Outside - Parked (outside)"
                    />
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-clock-o blueColor" />
                    <span className="gray"> Duration inside:</span>{" "}
                    {report.durationInside}{" "}
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-clock-o blueColor" />
                    <span className="gray"> Engine hours inside:</span>{" "}
                    {report.engineHoursInside}{" "}
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-clock-o blueColor" />
                    <span className="gray"> Moving Engine hours outside:</span>{" "}
                    {report.movingEngineHoursOutside}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="Total moving engine hours outside depot"
                    />
                  </span>
                  <br />
                </Col>
                <Col>
                  <span className="inlineDetail">
                    <i className="fa fa-calculator blueColor" />
                    <span className="gray"> Trips per hour:</span>{" "}
                    {report.tripsperhour}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="(Total Trips / Duration Outside) / 1 hour"
                    />
                  </span>
                  <br />
                  <span className="inlineDetail">
                    <i className="fa fa-calculator lightBlueColor" />
                    <span className="gray"> Distance per hour:</span>{" "}
                    {report.distancePerHour}{" "}
                    <i
                      className="fa fa-info-circle"
                      title="(Distance / Duration Outside) / 1 hour"
                    />
                  </span>
                  <br />
                </Col>
              </Row>
	    </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Summary;
